module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wide-leg-d826969a75db5dee5d7f42803765f8b7.png";